import React from "react";

import { OrderPreviewContextProvider } from "./context/order-preview-context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

class OrdersPreviewPage extends React.Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <OrderPreviewContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </OrderPreviewContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default OrdersPreviewPage;
